// extracted by mini-css-extract-plugin
export default {"list":"Languages-module__list__tmOvh","link":"Languages-module__link__T7N4Z","selected":"Languages-module__selected__RAxgg"};